<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <profile
          :profile="$store.state.user"
          :on-update="onUpdate"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <material-card
          class="v-card-profile"
          :loading="loadingUsers"
          color="primary"
        >
          <template v-slot:header>
            <div
              class="pa-3"
            >
              <h4
                class="title font-weight-light"
              >
                {{ company ? company.name : '' }}
              </h4>
            </div>

            <v-spacer />
            <!-- <v-btn
              color="secondary"
              class="mr-3"
              @click="$refs.addcontact.open()"
            >
              <v-icon class="pr-3">
                mdi-account-plus
              </v-icon>Add Contact
            </v-btn> -->
          </template>
          <v-progress-circular
            v-if="loadingUsers"
            :size="50"
            color="primary"
            indeterminate
          />
          <profile-list
            v-else
            :items="users"
            @select="onUserSelect"
          />
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Profile from '../components/Profile.vue'
  import ProfileList from '../components/core/ProfileList.vue'
  import moment from 'moment'
  export default {
    components: {
      Profile,
      ProfileList
    },
    data () {
      return {
        loadingUsers: false,
        users: [],
        user: {
          ...this.$store.state.user
        },
      }
    },
    computed: {
      company: function () {
        return this.$store.state.company
      }
    },
    mounted () {
      this.getUsers()
    },
    methods: {
      moment,
      onUpdate (updatedUser) {
        localStorage.setItem('claim', JSON.stringify(updatedUser))
        this.$store.commit('setUser', updatedUser)
        this.user = updatedUser
      },
      onUserSelect (user) {
        console.log(user)
      },
      getUsers () {
        if (this.company) {
          this.loadingUsers = true
          this.api.get('user/list/' + this.portalSideId + '/' + this.company.companyId)
            .then(result => {
              var users = result.data
              users.forEach(user => {
                user.sub1 = user.email
                user.sub2 = this.moment(user.created).format('DD-MM-YY')
              })
              this.users = users
              this.loadingUsers = false
            }, error => {
              this.loadingUsers = false
              this.error = error
            })
        }
      },
    }

  }
</script>
